import { ReservationSummary } from './reservation.model';

export class Event {
  uuid_event: string;
  event_name: { [key: string]: string };
  event_location: string;
  event_short_description: { [key: string]: string };
  event_long_description: { [key: string]: string };
  event_category_name: string;
  event_category_url: string;
  event_dates: Array<string>;
  is_waiting_list?: boolean;
  sold_out?: boolean;

  constructor(
    uuid: string,
    event_name: { [key: string]: string },
    event_location: string,
    short_description: { [key: string]: string },
    long_description: { [key: string]: string },
    dates: Array<string>,
    is_waiting_list?: boolean,
    sold_out?: boolean
  ) {
    this.uuid_event = uuid;
    this.event_name = event_name;
    this.event_location = event_location;
    this.event_short_description = short_description;
    this.event_long_description = long_description;
    this.event_dates = dates;
    this.is_waiting_list = is_waiting_list;
    this.sold_out = sold_out;
  }
}

export class DescLang {
  it?: string | undefined;
  en?: string | undefined;
  de?: string | undefined;
  fr?: string | undefined;
  es?: string | undefined;
  pt?: string | undefined;
}

export class BookedEvent {
  uuid_event: string;
  event_name: { [key: string]: string };
  event_short_description: { [key: string]: string };
  event_long_description: { [key: string]: string };
  event_category_name: string;
  event_category_url: string;
  associated_reservations: Array<ReservationSummary>;
  event_location: string;

  constructor(
    uuid: string,
    event_name: { [key: string]: string },
    short_description: { [key: string]: string },
    long_description: { [key: string]: string },
    event_category_name: string,
    event_category_url: string,
    event_location: string
  ) {
    this.uuid_event = uuid;
    this.event_name = event_name;
    this.event_short_description = short_description;
    this.event_long_description = long_description;
    this.event_category_url = event_category_url;
    this.event_category_name = event_category_name;
    this.event_location = event_location;
    this.associated_reservations = new Array<ReservationSummary>();
  }
}
